<template>
  <StandardLayout>
    <div slot="main" class="login-container mx-4 mx-md-12 my-6 d-flex flex-column flex-md-row align-center justify-center">
      <v-sheet class="login-left mr-0 mr-md-6 mb-6 mb-md-0 d-none d-md-block background-none" rounded>
        <v-img src="@/assets/login2.png" alt="Login" class="width-100 login-hero" cover aspect-ratio="4/3" rounded="lg"></v-img>
      </v-sheet>
      <v-card class="login-card login-right d-flex flex-column justify-center align-center py-8 px-6 px-md-8 height-100" elevation="8" rounded="xl">
        <v-avatar size="64" class="mb-4" tile>
          <v-img src="@/assets/logo.svg" alt="Ideaverse"></v-img>
        </v-avatar>
        <h1 class="outfit-regular text-h4 text-center">Login</h1>
        <p class="text-body-2 text-medium-emphasis mt-2 text-center">Welcome back. Sign in to continue.</p>
        <v-divider class="width-100 my-6"></v-divider>
        <AuthenticateComponent />
        <div class="text-caption text-medium-emphasis mt-4 text-center">
          Having trouble logging in? Contact us at <a href="mailto:support@ideaverse.org">support@ideaverse.org</a>
        </div>
      </v-card>
    </div>
  </StandardLayout>
</template>

<script>
import StandardLayout from '@/layouts/Standard.vue'
import AuthenticateComponent from '@/components/Authenticate.vue'
export default {

  name: 'LoginView',

  components: {
    StandardLayout,
    AuthenticateComponent
  }

}
</script>

<style scoped>
.login-container {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.08), rgba(16, 185, 129, 0.08));
  border-radius: 16px;
  padding: 16px;
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
  gap: 32px;
}

.login-left {
  flex: 1 1 60%;
}

.login-right {
  flex: 1 1 40%;
}

.login-card {
  width: 100%;
  max-width: 520px;
}

.login-hero {
  border-radius: 16px;
  height: 450px;
  aspect-ratio: 4/3;
}

@media (max-width: 960px) {
  .login-container {
    padding: 12px;
    border-radius: 12px;
    gap: 16px;
  }
}
</style>
